<template>
    <v-container fluid style="padding-top:calc((100vh - 64px - 128px) / 2)">
        <center>
        <svg class="loader" version="1.1" id="L6" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
            <rect fill="none" stroke="#888" stroke-width="4" x="25" y="25" width="50" height="50">
            <animateTransform
                attributeName="transform"
                dur="0.5s"
                from="0 50 50"
                to="180 50 50"
                type="rotate"
                id="strokeBox"
                attributeType="XML"
                begin="rectBox.end"/>
            </rect>
            <rect x="27" y="27" fill="#777" width="46" height="50">
            <animate
                attributeName="height"
                dur="1.3s"
                attributeType="XML"
                from="0"
                to="50"
                id="rectBox"
                fill="freeze"
                begin="0s;strokeBox.end"/>
            </rect>
        </svg>
        </center>
    </v-container>
</template>

<style scoped>
svg.loader {
    width: 128px;
    height: 128px;
    margin: 0px;
    display: inline-block;
}
</style>


<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
}
</script>
